export default "__VITE_ASSET__CcRIFinb__"